import { Box, Stack, Tooltip, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { PERMISSION_LABEL_KEYS } from '../permissionLabels'
import type { RecordAccessHolder } from './useRecordGrants'

type Props = {
  permissions: RecordAccessHolder['derivedPermissions']
}

/** What taking part in the record lets a subject do, counted on the row and named on hover. */
export const InheritedPermissionsSummary = ({ permissions }: Props) => {
  const { t } = useTranslation('settings', { keyPrefix: 'record-access' })
  // Permission names are shared with the permission-sets surfaces, so they sit under that prefix.
  const { t: permissionSetsT } = useTranslation('settings', { keyPrefix: 'permission-sets' })

  if (permissions.length === 0) return null

  return (
    <Tooltip
      placement="bottom-start"
      variant="fit-content"
      title={
        <Stack gap={0.5}>
          {permissions.map((permission) => (
            <Typography key={permission} variant="inherit" component="p">
              {permissionSetsT(PERMISSION_LABEL_KEYS[permission])}
            </Typography>
          ))}
        </Stack>
      }
    >
      <Box
        component="span"
        tabIndex={0}
        sx={{
          textDecoration: 'underline',
          textDecorationStyle: 'dotted',
          textUnderlineOffset: '3px',
          cursor: 'default',
        }}
      >
        {t('inherited-permission-count', { count: permissions.length })}
      </Box>
    </Tooltip>
  )
}
